module.exports = require('./helpers/bundle-url').getBundleURL('imVHt') + "logo.7718c6df.svg";